import { useState } from "react";
import { createBadge } from "../api";
import type { T } from "../i18n";

const metrics = ["points", "level", "current_streak", "longest_streak", "tips_count", "ratings_count"];

export function Gamification({ t }: { t: T }) {
  const [code, setCode] = useState("");
  const [metric, setMetric] = useState("tips_count");
  const [threshold, setThreshold] = useState("1");
  const [titleEn, setTitleEn] = useState("");
  const [msg, setMsg] = useState<string | null>(null);

  async function add() {
    setMsg(null);
    try {
      await createBadge(code, metric, parseInt(threshold, 10) || 0, titleEn ? { en: titleEn } : {});
      setCode("");
      setTitleEn("");
      setMsg("✓");
    } catch {
      setMsg(t("common.error"));
    }
  }

  return (
    <div>
      <div className="form-grid">
        <input placeholder={t("game.badge_code")} value={code} onChange={(e) => setCode(e.target.value)} />
        <input placeholder={t("tippages.greeting_en")} value={titleEn} onChange={(e) => setTitleEn(e.target.value)} />
        <select value={metric} onChange={(e) => setMetric(e.target.value)}>
          {metrics.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
        <input
          type="number"
          placeholder={t("game.threshold")}
          value={threshold}
          onChange={(e) => setThreshold(e.target.value)}
        />
        <button onClick={add} disabled={!code}>
          {t("game.add_badge")}
        </button>
      </div>
      {msg && <p className={msg === "✓" ? "ok" : "error"}>{msg}</p>}
    </div>
  );
}
